import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import Select from 'app/frontend/base/components/Select'

type Props = {
  enabled: boolean
  disabled?: boolean
  isPending?: boolean
  onEnabledChange: (enabled: boolean) => void
  className?: string
}

const DefaultSetupStatusSelect = ({
  enabled,
  disabled,
  isPending,
  onEnabledChange,
  className,
}: Props) => {
  const { t } = useTranslation()
  const statusOptions = useMemo(
    () => [
      {
        value: 'active',
        sortLabel: '0',
        label: t('dashboard.team.plans.default-setup.active'),
        description: t('dashboard.team.plans.default-setup.active-description'),
      },
      {
        value: 'inactive',
        sortLabel: '1',
        label: t('dashboard.team.plans.default-setup.inactive-label'),
        description: t(
          'dashboard.team.plans.default-setup.inactive-description',
        ),
      },
    ],
    [t],
  )

  return (
    <div onClick={(event) => event.stopPropagation()}>
      <Select
        value={enabled ? 'active' : 'inactive'}
        setValue={(next) => {
          if (next === 'active') onEnabledChange(true)
          if (next === 'inactive') onEnabledChange(false)
        }}
        options={statusOptions}
        disabled={disabled || isPending}
        optionWidth='fit'
        iconClassName='ml-0.5 h-3 w-3'
        className={cn(
          'h-9 w-36 shrink-0 px-2',
          enabled
            ? 'bg-success text-success-foreground hover:bg-success hover:text-success-foreground [&_svg]:text-success-foreground'
            : 'bg-warning text-warning-foreground hover:bg-warning hover:text-warning-foreground [&_svg]:text-warning-foreground',
          className,
        )}
      />
    </div>
  )
}

export default DefaultSetupStatusSelect
